// extracted by mini-css-extract-plugin
module.exports = {"AdCard":"AppPreviewAd_AdCard__1_AIN","CardBody":"AppPreviewAd_CardBody__18l9w","fadeOut":"AppPreviewAd_fadeOut__3IUNT","fadeIn":"AppPreviewAd_fadeIn__vfmJn"};